import React, { useCallback } from 'react';
import { useField } from 'formik';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export const CallRecordingSetting = React.memo(() => {
  const [field, meta, helpers] = useField<boolean>('is_call_recording_enabled');

  const onChange = useCallback(
    (value: string) => helpers.setValue(value === 'true'),
    [helpers.setValue]
  );

  return (
    <Card className="bg-muted rounded-2xl gap-0 p-1 border-0">
      <CardHeader className="px-5 py-3">
        <div>
          <CardTitle className="text-sm font-medium mb-1">Call Recording</CardTitle>
          <p className="text-sm text-muted-foreground">
            Enable or disable recording for calls handled by this agent.
          </p>
        </div>
      </CardHeader>
      <CardContent className="bg-card rounded-xl shadow-sm p-5">
        <Select value={String(field.value)} onValueChange={onChange}>
          <SelectTrigger className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="true">Enabled</SelectItem>
            <SelectItem value="false">Disabled</SelectItem>
          </SelectContent>
        </Select>
        {meta.error && meta.touched && (
          <p className="text-sm text-destructive mt-1">{meta.error}</p>
        )}
      </CardContent>
    </Card>
  );
});
